import cn from "classnames";
import s from "./Tags.module.scss";

const Tags = ({ className, children }) => {
  return <div className={cn(s.tags, className)}>{children}</div>;
};

export default Tags;
